// BotText.jsx  (your default bot-message renderer)
import React, { useEffect, useRef } from 'react';
import PropTypes                    from 'prop-types';

export default function BotText({ message }) {

  if (typeof message !== 'string') {
    console.warn('BotText received non-string:', message);
    return <pre>{JSON.stringify(message)}</pre>;
  }

  const el = useRef(null);

  /* run once – after the element is in the DOM */
  useEffect(() => {
    el.current?.classList.add('fade-in-up');
  }, []);

  return (
    <div
      ref={el}
      className='custom-html-message'
      style={{ lineHeight: 1.7, textAlign: 'left' }}
      dangerouslySetInnerHTML={{ __html: message }}
    />
  );
}

BotText.propTypes = { message: PropTypes.string.isRequired };